import { render, staticRenderFns } from "./aktuelles.vue?vue&type=template&id=1c8bbb0c&scoped=true&"
import script from "./aktuelles.vue?vue&type=script&lang=js&"
export * from "./aktuelles.vue?vue&type=script&lang=js&"
import style0 from "./aktuelles.vue?vue&type=style&index=0&id=1c8bbb0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bbb0c",
  null
  
)

export default component.exports